/**
 * What the Offline Mode switch does when the learner turns it ON.
 *
 * Switching OFF never discards bytes (it only revokes blob URLs), so a
 * course that was downloaded earlier is still on the device when the switch
 * goes back on. Tom, in flight 2026-10-02: he flipped it off and on in
 * airplane mode and the app refused, because ON always opened the depth
 * picker, whose only exit is a network download.
 *
 * Offline with something already downloaded, the right answer is to adopt
 * what is there and fetch nothing. Anything else keeps the picker.
 */
export type OfflineToggleOnAction = 'adopt' | 'picker'

export function resolveOfflineToggleOn(input: {
  networkUp: boolean
  alreadyDownloaded: boolean
}): OfflineToggleOnAction {
  return !input.networkUp && input.alreadyDownloaded ? 'adopt' : 'picker'
}
